/**
 * @generated SignedSource<<99dd335959135c08919935af86b53a5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DirectoryViewTeamQuery$variables = {
  cloudId: string;
  includeGoals: boolean;
  includeProjects: boolean;
  organisationId: string;
  teamQuery: string;
};
export type DirectoryViewTeamQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryViewPaginationQuery">;
};
export type DirectoryViewTeamQuery = {
  response: DirectoryViewTeamQuery$data;
  variables: DirectoryViewTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeGoals"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeProjects"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v7 = [
  (v5/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 24
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "teamQuery"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "description"
},
v10 = {
  "kind": "ScalarField",
  "name": "count"
},
v11 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewTeamQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "includeGoals",
            "variableName": "includeGoals"
          },
          {
            "kind": "Variable",
            "name": "includeProjects",
            "variableName": "includeProjects"
          },
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "teamQuery",
            "variableName": "teamQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DirectoryViewPaginationQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewTeamQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "TeamSearchResponseConnection",
        "kind": "LinkedField",
        "name": "teamsTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hasChildren"
                  },
                  {
                    "condition": "includeGoals",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "goals",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "concreteType": "GoalIcon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "appearance"
                                      }
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "includeProjects",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "ProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "concreteType": "ProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "private"
                                  },
                                  {
                                    "concreteType": "IconURIs",
                                    "kind": "LinkedField",
                                    "name": "iconUrl",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "ThemeURIs",
                                        "kind": "LinkedField",
                                        "name": "square",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "light"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "dark"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "transparent"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "smallAvatarImageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "concreteType": "TeamSearchResponseConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamSearchResponseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "memberCount"
                  },
                  {
                    "concreteType": "TeamMemberConnection",
                    "kind": "LinkedField",
                    "name": "searchMembers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TeamMemberEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "aaid"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "TeamType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "verified"
                      },
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "largeAvatarImageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v14/*: any*/)
                ]
              },
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "q",
          "organisationId",
          "cloudId"
        ],
        "handle": "connection",
        "key": "TeamDirectoryResults_teamsTql",
        "kind": "LinkedHandle",
        "name": "teamsTql"
      },
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "wrapTextEnabled"
              },
              (v8/*: any*/)
            ]
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e43bea98e3e3f97bf4c75d7ed8e27252",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewTeamQuery",
    "operationKind": "query",
    "text": "query DirectoryViewTeamQuery(\n  $teamQuery: String!\n  $organisationId: String!\n  $cloudId: String!\n  $includeGoals: Boolean!\n  $includeProjects: Boolean!\n) {\n  ...DirectoryViewPaginationQuery_4nU7jm\n}\n\nfragment DirectoryViewPaginationQuery_4nU7jm on Query {\n  teamsTql(q: $teamQuery, first: 24, organisationId: $organisationId, cloudId: $cloudId) {\n    ...DirectoryView_Results_2z59ss\n    edges {\n      __typename\n      cursor\n      node {\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  currentUser {\n    preferences {\n      wrapTextEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment DirectoryView_Results_2z59ss on TeamSearchResponseConnection {\n  ...TeamsDirectoryListView_2z59ss\n  ...TeamsDirectoryGridView\n}\n\nfragment GoalEntry on Goal {\n  ...GoalName\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment RootTeamDirectoryRow_2z59ss on TeamSearchResponse {\n  id\n  ...TeamDirectoryRowDetails_2z59ss\n}\n\nfragment TeamActions on TeamSearchResponse {\n  id\n}\n\nfragment TeamDirectoryCardDetails on TeamSearchResponse {\n  id\n  description\n  displayName\n  isVerified\n  smallAvatarImageUrl\n  ...TeamSearchAvatar\n  memberCount\n  state\n  type {\n    id\n    name\n    description\n    verified\n  }\n  searchMembers {\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n\nfragment TeamDirectoryRowDetails_2z59ss on TeamSearchResponse {\n  id\n  description\n  hasChildren\n  goals @include(if: $includeGoals) {\n    ...TeamGoals\n  }\n  projects @include(if: $includeProjects) {\n    ...TeamProjects\n  }\n  ...TeamNameColumn\n  ...TeamMemberAvatarColumn\n  ...TeamTypeColumn\n  ...TeamActions\n}\n\nfragment TeamGoals on GoalConnection {\n  count\n  edges {\n    node {\n      id\n      ...GoalEntry\n    }\n  }\n}\n\nfragment TeamMemberAvatarColumn on TeamSearchResponse {\n  memberCount\n  searchMembers {\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n\nfragment TeamNameColumn on TeamSearchResponse {\n  id\n  displayName\n  smallAvatarImageUrl\n  isVerified\n  hasChildren\n  description\n  children {\n    edges {\n      __typename\n    }\n  }\n}\n\nfragment TeamProjects on ProjectConnection {\n  count\n  edges {\n    node {\n      ...ProjectName_data\n      id\n    }\n  }\n}\n\nfragment TeamSearchAvatar on TeamSearchResponse {\n  id\n  displayName\n  isVerified\n  largeAvatarImageUrl\n}\n\nfragment TeamTypeColumn on TeamSearchResponse {\n  type {\n    name\n    verified\n    id\n  }\n}\n\nfragment TeamsDirectoryGridView on TeamSearchResponseConnection {\n  edges {\n    node {\n      id\n      ...TeamDirectoryCardDetails\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n\nfragment TeamsDirectoryListView_2z59ss on TeamSearchResponseConnection {\n  edges {\n    node {\n      id\n      ...RootTeamDirectoryRow_2z59ss\n    }\n  }\n  pageInfo {\n    hasNextPage\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1b2ed11557c80f04fd2a2d1f62f8f35";

export default node;
